import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dateZh from "./src/zh/date.json";
import dateEn from "./src/en/date.json";

Vue.use(VueI18n)

class i18n extends VueI18n {
    constructor() {
        super({
            locale: '',
            message: {},
            fallbackLocale: 'zh',
            dateTimeFormats: {
                zh: dateZh,
                en: dateEn
            }
        })
    }

    async init() {
        await this.setLocale('zh');
        await this.setLocale('en');
        this.locale = localStorage.getItem(process.env.VUE_APP_LANG_STORE_NAME) || "zh";

        return this;
    }

    async setLocale(lang) {
        const vm = this;
        const loadMessages = async function (lang) {
            const messages = {};
            const common = await import(`@/i18n/src/${lang}/common.json`);
            const common_format = vm.formatMessage(common.default);

            try {
                const msg = await import(`@/i18n/src/${lang}.json`);
                const msg_format = vm.formatMessage(msg.default);
                Object.assign(messages, msg_format, common_format);
            } catch {
                Object.assign(messages, common_format);
            }

            return messages;
        }

        const messages = await loadMessages(lang);
        this.setLocaleMessage(lang, messages);
    }

    formatMessage(data) {
        let d = {};
        if (data !== undefined && data !== null && typeof data === 'object' && Object.keys(data).length) {
            d = JSON.parse(JSON.stringify(data));
            for (let key in d) {
                if (d[`${key}_${process.env.VUE_APP_RUN_MODE}`]) {
                    d[key] = d[`${key}_${process.env.VUE_APP_RUN_MODE}`];
                } else if (typeof d[key] === 'object' && Object.keys(d[key]).length) {
                    d[key] = this.formatMessage(d[key]);
                }
            }
        }

        return d;
    }

}

export default new i18n();